export enum ToolName {
  RETURN_RESULTS = "return_results",
  SLEEP = "sleep",
  COMPUTER_AGENT = "computer_agent",
  CREATE_ANALYTICS_GRAPH = "create_analytics_graph",
}

export enum StreamEventType {
  DELTA = "delta",
  DEBUG = "debug",
  TOOL_CALL_STATUS = "tool_call_status",
  TOOL_CALL = "tool_call",
  TOOL_RESULT = "tool_result",
  TOOL_OUTPUT = "tool_output",
  TOOL_ERROR = "tool_error",
  DONE = "done",
  ERROR = "error",
  SESSION_CREATED = "session_created",
  SESSION_NAME_GENERATION_STARTED = "session_name_generation_started",
  SESSION_NAME_DELTA = "session_name_delta",
  SESSION_NAME_GENERATED = "session_name_generated",
  SESSION_NAME_GENERATION_ERROR = "session_name_generation_error",
  COMPUTER_AGENT_START = "computer_agent_start",
  COMPUTER_AGENT_PROGRESS = "computer_agent_progress",
  COMPUTER_AGENT_COMPLETE = "computer_agent_complete",
  COMPUTER_AGENT_ERROR = "computer_agent_error",
}

export enum MessageRole {
  USER = "user",
  ASSISTANT = "assistant",
  MASTER_VIBE_PROMPT = "master-vibe-prompt",
  TOOL_CALL = "tool-call",
  COMPUTER_AGENT = "computer-agent",
}

export enum ToolCallStatus {
  PENDING = "pending",
  RUNNING = "running",
  COMPLETED = "completed",
  ERROR = "error",
  FAILED = "failed",
}

export enum ToolCategory {
  ANALYTICS = "analytics",
  DATABASE = "database",
  SEARCH = "search",
  CODE = "code",
  DEFAULT = "default",
}

export enum ComputerAgentDataStatus {
  RUNNING = "running",
  COMPLETED = "completed",
  ERROR = "error",
  CANCELLED = "cancelled",
}

export const RESOURCE_TYPES = {
  PROMPT: "prompt",
  DATASET: "dataset",
  BLUEPRINT: "blueprint",
  FOLDER: "folder",
  WORKFLOW: "workflow",
} as const;

export type ResourceType = (typeof RESOURCE_TYPES)[keyof typeof RESOURCE_TYPES];
